module.exports = __webpack_public_path__ + "static/media/crohns4.665c27dc.jpg";